(() => {
  const nav = document.querySelector('[data-ff-mega-nav]');
  const headerWrapper = document.querySelector('.ff-header-wrapper');
  if (nav) {
    const items = [...nav.querySelectorAll('[data-ff-mega-item]')];
    let openItem = null;
    let closeTimer = null;

    const closeAll = () => {
      window.clearTimeout(closeTimer);
      items.forEach((item) => {
        item.classList.remove('is-open');
        const trigger = item.querySelector('.ff-mega-nav__trigger');
        const panel = item.querySelector('.ff-mega-panel');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        if (panel) panel.classList.remove('is-open');
      });
      if (headerWrapper) headerWrapper.classList.remove('is-mega-open');
      openItem = null;
    };

    const openItemPanel = (item) => {
      window.clearTimeout(closeTimer);
      if (openItem === item) return;
      closeAll();
      item.classList.add('is-open');
      const trigger = item.querySelector('.ff-mega-nav__trigger');
      const panel = item.querySelector('.ff-mega-panel');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      if (panel) panel.classList.add('is-open');
      if (headerWrapper) headerWrapper.classList.add('is-mega-open');
      openItem = item;
    };

    items.forEach((item) => {
      const trigger = item.querySelector('.ff-mega-nav__trigger');
      const panel = item.querySelector('.ff-mega-panel');
      if (!trigger || !panel) return;

      // Handle item (trigger + panel) as ONE unified interactive hover region
      item.addEventListener('mouseenter', () => {
        window.clearTimeout(closeTimer);
        openItemPanel(item);
      });

      item.addEventListener('mouseleave', (event) => {
        // If moving between trigger and panel or between children of the same item, keep it open
        if (event.relatedTarget && item.contains(event.relatedTarget)) {
          return;
        }
        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(closeAll, 200);
      });

      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (openItem === item) {
          closeAll();
        } else {
          openItemPanel(item);
        }
      });
    });

    // Close on click outside (including clicking the page backdrop)
    document.addEventListener('click', (event) => {
      const target = event.target;
      const insideNav = nav.contains(target);
      const insidePanel = [...items].some((item) => {
        const panel = item.querySelector('.ff-mega-panel');
        return panel && panel.contains(target);
      });
      if (!insideNav && !insidePanel) closeAll();
    });

    // Close on Escape key
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeAll();
    });
  }

  const drawer = document.querySelector('[data-ff-mega-drawer]');
  if (drawer) {
    const closeDrawer = () => {
      drawer.open = false;
    };

    drawer.querySelectorAll('[data-ff-drawer-close]').forEach((button) => {
      button.addEventListener('click', closeDrawer);
    });

    drawer.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', closeDrawer);
    });

    drawer.addEventListener('toggle', () => {
      document.documentElement.classList.toggle('ff-mega-drawer-open', drawer.open);
    });
  }

  const searchToggle = document.querySelector('[data-ff-search-toggle]');
  const searchPanel = document.querySelector('[data-ff-search-panel]');
  const searchBackdrop = document.querySelector('[data-ff-search-backdrop]');
  const searchInput = document.querySelector('[data-ff-search-input]');
  const searchCloseButtons = document.querySelectorAll('[data-ff-search-close]');

  if (searchToggle && searchPanel) {
    const openSearch = () => {
      searchPanel.hidden = false;
      if (searchBackdrop) {
        searchBackdrop.hidden = false;
        searchBackdrop.setAttribute('aria-hidden', 'false');
      }
      searchToggle.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('ff-header-search-open');
      window.requestAnimationFrame(() => {
        if (searchInput) searchInput.focus();
      });
    };

    const closeSearch = () => {
      searchPanel.hidden = true;
      if (searchBackdrop) {
        searchBackdrop.hidden = true;
        searchBackdrop.setAttribute('aria-hidden', 'true');
      }
      searchToggle.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('ff-header-search-open');
    };

    searchToggle.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (searchPanel.hidden) openSearch();
      else closeSearch();
    });

    searchCloseButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        closeSearch();
      });
    });

    if (searchBackdrop) {
      searchBackdrop.addEventListener('click', closeSearch);
    }

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !searchPanel.hidden) {
        closeSearch();
        searchToggle.focus();
      }
    });

    document.addEventListener('click', (event) => {
      if (searchPanel.hidden) return;
      const target = event.target;
      if (
        searchPanel.contains(target) ||
        searchToggle.contains(target) ||
        (searchBackdrop && searchBackdrop.contains(target))
      ) {
        return;
      }
      closeSearch();
    });
  }
})();
